import { Icon } from "@iconify/react";
export const ParticipantCard = ({ participant = null, remainingCount = null, style = {} }) => {

  if (remainingCount !== null) {
    if (remainingCount <= 0) {
      return null;
    }

    return (
      <div
        style={{
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          padding: "12px",
          marginBottom: "10px",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          ...style,
        }}
      >
        <div
          style={{
            height: "30px",
            width: "30px",
            borderRadius: "50%",
            backgroundColor: "#f0f0f0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 600,
            zIndex: 1,
          }}
        />
        <div
          style={{
            height: "30px",
            width: "30px",
            borderRadius: "50%",
            backgroundColor: "#c0c0c0",
            marginLeft: "-15px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 600,
            zIndex: 2,
          }}
        />
        <div
          style={{
            height: "30px",
            width: "30px",
            borderRadius: "50%",
            backgroundColor: "#a0a0a0",
            marginRight: "20px",
            marginLeft: "-15px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: 600,
            color: "#888888",
            zIndex: 3,
          }}
        >
          <Icon icon="mdi:account-multiple" width="20" height="20" style={{ color: "#e0e0e0" }} />
        </div>

        <div style={{ fontWeight: 600 }}>
          {remainingCount} more participant{remainingCount > 1 ? "s " : " "}
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        padding: "12px",
        marginBottom: "10px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        ...style,
      }}
    >
      <div
        style={{
          height: "30px",
          width: "30px",
          borderRadius: "50%",
          backgroundColor: "#f9d8b5",
          marginRight: "10px",
          position: "relative",
        }}
      >
        {participant?.icon_background ? (
          <img
            src={require(`../../assets/live-event-icons/${participant.icon_background}.png`)}
            alt="participant Avatar"
            style={{
              width: "100%",
              height: "100%",
              borderRadius: "50%",
            }}
          />
        ) : null}
        {participant?.icon_name ? (
          <img
            src={require(`../../assets/live-event-icons/${participant.icon_name}.png`)}
            alt="participant Avatar"
            style={{
              width: "20px",
              height: "20px",
              borderRadius: "50%",
              position: "absolute",
              top: "5px",
              left: "5px",
            }}
          />
        ) : null}
      </div>
      <div style={{ fontWeight: 600, marginRight: 10 }}>
        {participant?.nickname?.replace(" null", "") ?? `Unknown participant`}
      </div>
    </div>
  );
};

export default ParticipantCard;
